/**
 *
 *  Copy to clipboard
 *
 *  Created by Vladimir Shishlyannikov on 28/02/2023.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

export default function copy(text) {
  var selected,
    selection,
    range, // eslint-disable-line no-unused-vars
    elem,
    success = false;

  try {
    selected =
      document.getSelection().rangeCount > 0 // Check if there is any content selected previously
        ? document.getSelection().getRangeAt(0) // Store selection if found
        : false;

    selection = window.getSelection(); // eslint-disable-line no-unused-vars

    elem = document.createElement("textarea");
    elem.value = text;

    // For iOS
    elem.contentEditable = true;
    elem.setAttribute("readonly", "");

    // Place in top-left corner of screen regardless of scroll position
    elem.style.position = "fixed";
    elem.style.top = 0;
    elem.style.left = 0;

    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    elem.style.width = "1px";
    elem.style.height = "1px";

    // We don't need padding, reducing the size if it does flash render.
    elem.style.padding = 0;

    // Clean up any borders.
    elem.style.border = "none";
    elem.style.outline = "none";
    elem.style.boxShadow = "none";

    document.body.appendChild(elem);

    elem.select();

    elem.setSelectionRange(0, elem.value.length); // A big number, to cover anything that could be inside the element

    success = document.execCommand("copy");
  } finally {
    if (elem) {
      document.body.removeChild(elem);
    }

    if (selected) {
      // If a selection existed before copying
      document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
      document.getSelection().addRange(selected); // Restore the original selection
    }
  }

  return success;
}
